import { useQuery } from "react-query";
import { getFranchiseAgreementsCount } from "../../../../actions/CarrierAgreementMgmt/Agreements";

const useFranchiseAgreementCount = () => {
  return useQuery("GetFranchiseAgreementCount", getFranchiseAgreementsCount, {
    refetchOnWindowFocus: false,
  });
};

export default useFranchiseAgreementCount;
